/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ManageRoles } from '../models/manage-roles';
import { Practice } from '../models/practice';
import { practicesGetAllGroups } from '../fn/practices/practices-get-all-groups';
import { PracticesGetAllGroups$Params } from '../fn/practices/practices-get-all-groups';
import { practicesGetAllPractices } from '../fn/practices/practices-get-all-practices';
import { PracticesGetAllPractices$Params } from '../fn/practices/practices-get-all-practices';

@Injectable({ providedIn: 'root' })
export class PracticesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `practicesGetAllGroups()` */
  static readonly PracticesGetAllGroupsPath = '/practices/{practiceId}/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practicesGetAllGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  practicesGetAllGroups$Response(params: PracticesGetAllGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManageRoles>>> {
    return practicesGetAllGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practicesGetAllGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practicesGetAllGroups(params: PracticesGetAllGroups$Params, context?: HttpContext): Observable<Array<ManageRoles>> {
    return this.practicesGetAllGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ManageRoles>>): Array<ManageRoles> => r.body)
    );
  }

  /** Path part for operation `practicesGetAllPractices()` */
  static readonly PracticesGetAllPracticesPath = '/practices/availablepractices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practicesGetAllPractices()` instead.
   *
   * This method doesn't expect any request body.
   */
  practicesGetAllPractices$Response(params?: PracticesGetAllPractices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
    return practicesGetAllPractices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practicesGetAllPractices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practicesGetAllPractices(params?: PracticesGetAllPractices$Params, context?: HttpContext): Observable<Array<Practice>> {
    return this.practicesGetAllPractices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Practice>>): Array<Practice> => r.body)
    );
  }

}
